module.exports = __webpack_public_path__ + "static/projects-details1-b546f855d8a5f572029ac829a5f2fefa.jpg";